<template>
<div class="customer_reviews">

    <div class="title_box" v-if="filterChk">
        <h4 class="title">고객후기<span>{{totalCount}}</span></h4>

        <select class="nojs_select" v-model="filter">
            <option value="" selected>전체</option>
            <option v-for="(score, key) in RATING_SORT_TYPE" :key="key" :value="score.id">
                {{score.title}}
            </option>
        </select>

    </div> 

    <h4 class="title" v-else>고객후기<span>{{totalCount}}</span></h4>

    <div class="contants">

        <template v-if="items.length > 0">

            <ul class="customer_reviews_ul" >
                <ReviewItem v-for="(item, idx) in items" 
                    :key="`review-item-${idx}`"
                    :createDt="item.createDt"
                    :name="encryption(item.userName)"
                    :title="item.trimName"
                    :content="item.content"
                    :score="item.score"
                    :rating="item.rating"
                />
            </ul>

            <router-link v-if="!filterChk" :to="to">전체보기<i class="far fa-chevron-down"></i></router-link>

        </template>

        
        <none-data title="작성된 리뷰가 없습니다." v-else/>

    </div>

</div> 
</template>

<script>
import { mapState } from 'vuex'
import ReviewItem from './ReviewItem.vue'
export default {
    name:'ReviewList',
    components: {
        ReviewItem,
    },
    props: {
        filterChk:{
            type:Boolean,
            default:() => false,
        },
        value:{
            type:String,
            default:() => '',
        },
        items: {
            type: Array,
            default: () => [],
        },
        totalCount:{
            type: Number,
            default: () => 0,
        },
        to:{
            type: String,
            default: () => '',
        },
    },
    
    computed: {
        ...mapState({
            REVIEW_SCORE: state => state.codeDictionary.items.REVIEW_SCORE,
            RATING_SORT_TYPE: state => state.codeDictionary.items.RATING_SORT_TYPE
        }),
        
        filter: {
            get(){ return this.value},
            set(val){ return this.$emit('input', val)},
        },
    },

    destroyed() {
        this.$store.commit('CLEAR_REVIEW_LIST');
    },

    methods: {
        encryption(name) {
            let encryptionName = name.substring(0, 1);

            if(name.length == 2)
                encryptionName += '*';
            else
                encryptionName += '*' + name.substring(2);

            return encryptionName;
        }
    }
    
}
</script>

<style scoped>
</style>